import { css } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";

/** CSS affecting the {@link RouletteComponent} */
const styles: string = css`
    button {
        color: white;
        background-color: #587D71;
        border: 3px solid #7798AB;
        padding: 5px 10px;
        margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        border-radius: 5px;
    }
    .black {
        background-color: black;
    }
    .red {
        background-color: red;
    }
    .green {
        background-color: green;
    }
    .hidden {
        display: none;
    }
`;

export class RouletteComponent extends HTMLElement {
    private gameRouteService: GameRouteService;

    public constructor() {
        super();
        this.gameRouteService = new GameRouteService();
    }

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
        this.addEventListeners();
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            <div class="content">
                <button class="black" id="blackButton">Black</button>
                <button class="red" id="redButton">Red</button>
                <button class="green" id="greenButton">Green</button>
                <div id="message"></div>
            </div>
        `;
    }

    private addEventListeners(): void {
        this.shadowRoot?.getElementById("blackButton")?.addEventListener("click", () => this.handleButtonClick("black"));
        this.shadowRoot?.getElementById("redButton")?.addEventListener("click", () => this.handleButtonClick("red"));
        this.shadowRoot?.getElementById("greenButton")?.addEventListener("click", () => this.handleButtonClick("green"));
    }

    private async handleButtonClick(color: string): Promise<void> {
        try {
            const result: { gameResult: boolean } = await this.gameRouteService.getRouletteStatus(color);

            const messageElement: HTMLElement | null = this.shadowRoot?.getElementById("message") as HTMLElement | null;
            if (messageElement) {
                messageElement.textContent = result.gameResult ? "You win! You doubled your chips, return to the reception to retrieve money." : "You lose! Better luck next time. Return to the reception to get your items back.";
            }
            this.shadowRoot?.querySelectorAll("button").forEach((button: HTMLElement) => button.classList.add("hidden"));
        }
        catch (error) {
            console.error("Failed to fetch roulette status:", error);
        }
    }
}
